<template>
    <v-dialog v-model="isOpen" persistent width="500">
        <v-card>
            <v-toolbar dense dark flat color="primary">
                <v-toolbar-title>Cancelar emisión</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-3">
                <p class="text-base">Selecciona el motivo de cancelación</p>
                <v-form v-model="isFormValid" ref="form">
                    <v-row>
                        <v-col cols="12">
                            <v-select v-model="motivoCancelacion" :items="motivosCancelacion"
                                label="Motivo de cancelación" outlined item-text="motivoCancelacion"
                                item-value="motivoCancelacion" :rules="[v => !!v || 'El motivo es requerido']" />
                        </v-col>
                    </v-row>
                    <v-row v-if="showNumberSmsSection">
                        <v-col cols="12">
                            <p class="mb-3">
                                Para continuar, escribe el número de celular del cliente al que se
                                enviará el SMS para confirmar la cancelación de su seguro
                            </p>
                            <v-text-field v-model="numeroSms" label="Número de celular" type="tel" maxlength="10"
                                :rules="reglasNumeroSms" prepend-inner-icon="mdi-cellphone" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions class="d-md-flex justify-end">
                <v-btn color="secondary" text class="mr-2" @click="cancel">
                    <span>Cancelar</span>
                </v-btn>
                <v-btn color="primary" :disabled="!isFormValid" @click="confirm">
                    <span>Confirmar cancelación</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CancelacionDialog",
    data() {
        return {
            isOpen: false,
            numeroSms: null,
            isFormValid: false,
            motivoCancelacion: null,
            pendingAction: null
        };
    },
    methods: {
        open(action) {
            this.pendingAction = action;
            this.motivoCancelacion = null;
            this.isOpen = true;
        },

        async confirm() {
            this.isValidating = true;
            const isValid = await this.$refs.form.validate();
            if (!isValid) return;
            const motivoCapturado = this.motivoCancelacion;
            const debeMostrarCapturado = this.debeMostrarCancelacionDialog;
            const numeroSmsCapturado = this.numeroSms;
            this.isOpen = false;

            if (this.pendingAction) {
                this.pendingAction(motivoCapturado, debeMostrarCapturado, numeroSmsCapturado);
            }
            this.isOpen = false;
        },

        cancel() {
            this.isOpen = false;
            this.motivoCancelacion = null;
        }
    },
    props: {
        motivosCancelacion: {
            type: Array,
            default: () => []
        },
        productoAseguradora: {
            type: String,
            default: ""
        },
        statusPoliza: {
            type: String,
            default: ""
        },
        telefonoContacto: {
            type: String,
            default: ""
        }
    },
    computed: {
        debeMostrarCancelacionDialog() {
            const motivosRequierenDialog = [
                { id: 19, name: "Cambio de plan" },
                { id: 20, name: "Cambio de contratante" },
                { id: 21, name: "Cambio de plan y contratante" },
                ...(this.productoAseguradora == "Hogar"
                    ? [{ id: 22, name: "Cambio de dirección" }]
                    : []),
            ];
            const motivoEncontrado = motivosRequierenDialog.find(
                (e) => e.name == this.motivoCancelacion
            );
            return !!motivoEncontrado;
        },
        reglasNumeroSms() {
            return [
                v => {
                    if (!this.showNumberSmsSection) return true;
                    return !!v || 'El número de celular es requerido';
                },
                v => {
                    if (!this.showNumberSmsSection || !v) return true;
                    return v.length === 10 || 'El número debe tener 10 dígitos';
                },
                v => {
                    if (!this.showNumberSmsSection || !v) return true;
                    return /^\d+$/.test(v) || 'Solo se permiten dígitos';
                }
            ];
        },
        showNumberSmsSection() {
            if (!["Nueva", "Emitido el certificado"].includes(this.statusPoliza) && !this.debeMostrarCancelacionDialog) {
                return true;
            }
            return false;
        }
    },
    watch: {
        motivoCancelacion(newVal) {
            if (newVal) {
                if (this.showNumberSmsSection) {
                    this.numeroSms = null;
                } else {
                    this.numeroSms = this.telefonoContacto;
                }
            }
        },
        isOpen(newVal) {
            if (!newVal) {
                this.$refs.form?.reset();
            }
        }
    }
};
</script>

<style scoped>
.text-base {
    font-size: 16px;
    line-height: 1.5;
}
</style>